/**
 * Export API Client
 * Phase 2: Wholesale Partnership Module
 */

import apiClient from '../client';

const BASE_URL = '/wholesale/exports';

// ===== REPORT EXPORTS =====

/**
 * Export sales report
 */
export const exportSalesReport = async (filters = {}, format = 'csv') => {
  try {
    const params = { ...filters, format };
    const response = await apiClient.get(`${BASE_URL}/sales`, { params });
    return response.data;
  } catch (error) {
    console.error('Error exporting sales report:', error);
    throw {
      message: error.response?.data?.error || 'Failed to export sales report',
      status: error.response?.status,
      details: error.response?.data
    };
  }
};

/**
 * Export customer performance report
 */
export const exportCustomerPerformanceReport = async (filters = {}, format = 'csv') => {
  try {
    const params = { ...filters, format };
    const response = await apiClient.get(`${BASE_URL}/customers`, { params });
    return response.data;
  } catch (error) {
    console.error('Error exporting customer performance report:', error);
    throw {
      message: error.response?.data?.error || 'Failed to export customer performance report',
      status: error.response?.status,
      details: error.response?.data
    };
  }
};

/**
 * Export revenue analysis report
 */
export const exportRevenueAnalysisReport = async (filters = {}, format = 'csv') => {
  try {
    const params = { ...filters, format };
    const response = await apiClient.get(`${BASE_URL}/revenue`, { params });
    return response.data;
  } catch (error) {
    console.error('Error exporting revenue analysis report:', error);
    throw {
      message: error.response?.data?.error || 'Failed to export revenue analysis report',
      status: error.response?.status,
      details: error.response?.data
    };
  }
};

/**
 * Export invoices
 */
export const exportInvoices = async (filters = {}, format = 'csv') => {
  try {
    const params = { ...filters, format };
    const response = await apiClient.get(`${BASE_URL}/invoices`, { params });
    return response.data;
  } catch (error) {
    console.error('Error exporting invoices:', error);
    throw {
      message: error.response?.data?.error || 'Failed to export invoices',
      status: error.response?.status,
      details: error.response?.data
    };
  }
};

/**
 * Export distributors
 */
export const exportDistributors = async (filters = {}, format = 'csv') => {
  try {
    const params = { ...filters, format };
    const response = await apiClient.get(`${BASE_URL}/distributors`, { params });
    return response.data;
  } catch (error) {
    console.error('Error exporting distributors:', error);
    throw {
      message: error.response?.data?.error || 'Failed to export distributors',
      status: error.response?.status,
      details: error.response?.data
    };
  }
};

/**
 * Download file from URL
 * Helper function to trigger browser download
 */
export const downloadFile = (fileUrl, filename) => {
  const link = document.createElement('a');
  link.href = fileUrl;
  link.download = filename || 'export.csv';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export default {
  exportSalesReport,
  exportCustomerPerformanceReport,
  exportRevenueAnalysisReport,
  exportInvoices,
  exportDistributors,
  downloadFile
};
